import React from 'react';
import { toast } from 'sonner';
import { TipReceivedToast } from './TipReceivedToast';
import { TipSentToast } from './TipSentToast';
import { RewardClaimToast } from './RewardClaimToast';
import { TIP_TOAST_OPTIONS } from './TipToastFrame';

// Reuse the exact production toast and sound, never dispatch a financial event.
export const showTestAlert = (notice, toastIds, playSound) => {
  const id = `test-${notice.id}`, dismiss = () => toast.dismiss(id);
  const receipt = { request_id: notice.id, amount_minor: notice.amount_minor, test_only: true, recipient_username: notice.sender_name, kind: notice.alert_type };
  toast.custom(() => notice.alert_type === 'tip_received' ? <TipReceivedToast notice={notice} dismiss={dismiss} />
    : notice.alert_type === 'tip_sent' ? <TipSentToast receipt={receipt} dismiss={dismiss} /> : <RewardClaimToast receipt={receipt} dismiss={dismiss} />, { ...TIP_TOAST_OPTIONS, id });
  toastIds.current.push(id); playSound(id);
};